// extracted by mini-css-extract-plugin
export default {"root":"ConversationListSection_root__IkAVr"};